/* eslint-disable no-empty */
import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const AUTH_CHANNEL = "session-sync";

// Broadcast login event
export const broadcastLogin = () => {
  const bc = new BroadcastChannel(AUTH_CHANNEL);
  bc.postMessage({ type: "login" });
};

// Broadcast logout event
export const broadcastLogout = () => {
  const bc = new BroadcastChannel(AUTH_CHANNEL);
  bc.postMessage({ type: "logout" });
};

export function useSessionSync() {
  const bcRef = useRef(null);
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const bc = new BroadcastChannel(AUTH_CHANNEL);
    bcRef.current = bc;

    bc.onmessage = async (event) => {
      const { type } = event.data;

      if (type === "login") {
        try {
          // You can handle the token logic here if you want
          const response = await instance.acquireTokenSilent({
            account: accounts[0],
            scopes: ["User.Read"],
          });
          // window.location.reload();
          if (response?.accessToken) {
            toast.dismiss();
            navigate("/landing", { replace: true });
          }
        } catch (error) {
        }
      }

      if (type === "logout") {
        // Clear session, local storage, etc.
        localStorage.clear();
        sessionStorage.clear();
        instance.clearCache();
        instance.setActiveAccount(null);
        navigate("/", { replace: true });
      }
    };

    return () => {
      bc.close();
      bcRef.current = null;
    };
  }, [accounts, instance, navigate]);

  return null;
}
